import { nextTick } from 'vue'
import { Tenant } from '@velociti/core'

export const initTheme = (tenant: Tenant) => {
  setPageTitle(tenant)
  setFavicon(tenant)
}

export const setPageTitle = (tenant: Tenant) =>
  void nextTick(() => {
    document.title = tenant.htmlTitle || 'REP Sales Tool'
  })

export const setFavicon = (tenant: Tenant) =>
  void nextTick(() => {
    const favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement

    if (!favicon) {
      return
    }

    favicon.href = tenant.favicon || '/favicon.ico'
  })
